// src/pages/Pedido/ResumoPedidoSemLogin.js
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/Form/Header';
import Footer from '../../components/Form/Footer';
import { FaRegCheckSquare } from "react-icons/fa";
import './ResumoPedido.css';
import MainContent from '../../components/Form/MainContent';
import { formatCurrency } from '../../utils/numberUtils';
import { BsDot } from 'react-icons/bs';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import food from "../../images/food.ico";
import { useTheme } from '../../contexts/ThemeContext';
import { getPedidoNumero } from '../../utils/pedidoUtils';

const ResumoPedidoSemLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { configModulo } = useTheme();
  const pedido = location.state?.pedido; // Recebe o objeto pedido via state

  useEffect(() => {
    if (!pedido) {
      // Se não houver pedido no state, redireciona para a página inicial
      navigate('/');
      return;
    }

    // Enviar notificação inicial
    toast.info(`Seu pedido #${getPedidoNumero(pedido, configModulo?.UsaIdDia)} foi confirmado! Acompanhe as atualizações pelo WhatsApp.`, {
      position: "top-right",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      icon: food,
    });
  }, [pedido, navigate, configModulo]);

  const formatDate = (date) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(date).toLocaleDateString("pt-BR", options);
  };

  const handleOkClick = () => {
    navigate('/');
  };

  if (!pedido) {
    return <p>Carregando...</p>;
  }

  return (
    <>
      <Header titulo="Resumo do Pedido" routeGoBack="/" />
      <MainContent>
        <div className="resumo-container">
          <FaRegCheckSquare color={'#27a732'} size={60}/>
          <h3>Pedido #{getPedidoNumero(pedido, configModulo?.UsaIdDia)} Confirmado</h3>
          <p>Realizado em: {formatDate(pedido.dataHoraPedido)}</p>
          <p>✅ Seu pedido foi confirmado! 🚀 Acompanhe as atualizações pelo WhatsApp 📢📲</p>

          <h4>Itens do Pedido</h4>
          <ul>
            {pedido.pedidoItens.map((item) => (
              <li key={item.id}>
                {item.apresentacao && item.apresentacao} Produto: {item.produto.descricao}, {item.qtde}un., Total Item: R$ {formatCurrency(item.valorTotal)}
                {item.variacao && <p>{item.produto.variacao?.descricao}: <strong>{item.variacao}</strong></p>}
                {item.observacao && <p>Obs: {item.observacao}</p>}
                
                {item.pedidoItemSabores && item.pedidoItemSabores.length > 0 && (
                  <div className="sabores2">                  
                    <ul>
                      <li>
                        {item.pedidoItemSabores.map((sabor, saborIndex) => (
                          <span key={saborIndex}>
                            <BsDot/>{sabor.sabor.descricao}
                          </span>
                        ))}
                      </li>
                    </ul>
                  </div>
                )}
              </li>
            ))}
          </ul>

          {pedido.endereco && (
            <>
              <h4>Informações de Entrega</h4>
              <p>Endereço: {pedido.endereco.logradouro}, {pedido.endereco.numero}, {pedido.endereco.bairro}, {pedido.endereco.cidade?.nome}/RS</p>
              {pedido.endereco.complemento && <p>Complemento: {pedido.endereco.complemento}</p>}
            </>
          )}

          <p>Cliente: {pedido.nomeCliente}</p>
          <p>Telefone: {pedido.telefoneCliente}</p>

          <h4>Forma de Pagamento</h4>
          <p>{pedido.formaPag?.descricao}</p>

          <h4>Valores</h4>
          <p>Valor dos Itens: R$ {formatCurrency(pedido.valorItens)}</p>
          {pedido.taxaEntrega > 0 && <p>Taxa de Entrega: R$ {formatCurrency(pedido.taxaEntrega)}</p>}
          {pedido.valorDesconto > 0 && <p>Desconto: -{formatCurrency(pedido.valorDesconto)}</p>}
          <p><b>Total: {formatCurrency(pedido.valorTotal)}</b></p>

          <button className="ok-button" onClick={handleOkClick}>OK</button>
        </div>
      </MainContent>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default ResumoPedidoSemLogin;
